import {
  CaseSummaryDTO,
} from '../models/CaseDTOs';
import {
  CaseReportSummary,
  CaseReport,
} from '../models/CaseTypes';
import caseList from '../__tests__/mock/CaseListAPI.json';
import caseJson1 from '../__tests__/mock/CaseReportAPIDetail1.json';
import caseJson2 from '../__tests__/mock/CaseReportAPIDetail2.json';
import caseJson3 from '../__tests__/mock/CaseReportAPIDetail3.json';
import caseJsonNoSegments from '../__tests__/mock/CaseReportAPIDetailMissingData.json';
import caseJsonRecordingOnly from '../__tests__/mock/CaseReportAPINoIOM.json';
import caseJsonV12MultiLevel from '../__tests__/mock/CaseReportAPIDetail_V12MultiLevel.json';
import caseJsonV12Single from '../__tests__/mock/CaseReportAPIDetail_V12Single.json';
import caseJsonV12NoPost from '../__tests__/mock/CaseReportAPIDetail_V12NoPost.json';
import caseJsonV11Legacy from '../__tests__/mock/CaseReportAPIDetail_V11Legacy.json';
import CaseReportAdapter from '../models/CaseReportAdapter';

import ICaseReportService from './ICaseReportService';

export default class MockCaseReportService implements ICaseReportService {
  caseReportAdapter = new CaseReportAdapter();
  mode: string;

  constructor(mode: string) {
    this.mode = mode;
  }

  clearCache(): void {
  }

  async getCaseDetail(caseId: string): Promise<CaseReport> {
    switch (caseId) {
    case 'SITE001-001-20250102':
      return this.caseReportAdapter.mapToViewModel(caseJson1);
    case 'SITE001-002-20250203':
      return this.caseReportAdapter.mapToViewModel(caseJson2);
    case 'SITE001-003-20250501':
      return this.caseReportAdapter.mapToViewModel(caseJson3);
    case 'SITE001-NOCHILDDATA':
      return this.caseReportAdapter.mapToViewModel(caseJsonNoSegments);
    case 'SITE001-RECORDINGONLY':
      return this.caseReportAdapter.mapToViewModel(caseJsonRecordingOnly);
    case 'SITE001-V12-MULTILEVEL':
      return this.caseReportAdapter.mapToViewModel(caseJsonV12MultiLevel);
    case 'SITE001-V12-SINGLE':
      return this.caseReportAdapter.mapToViewModel(caseJsonV12Single);
    case 'SITE001-V12-NOPOST':
      return this.caseReportAdapter.mapToViewModel(caseJsonV12NoPost);
    case 'SITE001-V11-LEGACY':
      return this.caseReportAdapter.mapToViewModel(caseJsonV11Legacy);
    default:
      throw new Error(`Case ID ${caseId} not found in mock data.`);
    }
  }

  async getCaseSummaries(): Promise<CaseReportSummary[]> {
    if (this.mode === 'test_no_data') {
      return [];
    }

    const summaries = caseList.map((caseSummary: CaseSummaryDTO) => (
      this.caseReportAdapter.mapToSummaryViewModel(caseSummary)
    ));
    return summaries;
  }

  async getServiceHealth(): Promise<object> {
    return { status: 'ok', message: 'Mock service is healthy' };
  }
}
